import { passwordInputType } from 'portal/src/components/common/forms/FormFieldTypes';

type UpdatePwFormValues = ReturnType<typeof defaultValues>;

export const defaultValues = () => ({
  newPassword: '',
  confirmPassword: '',
});

const validatePasswordsMatch = (
  pw: string,
  confirmPw: string,
): boolean | string => (pw !== confirmPw ? 'Passwords do not match.' : true);

export const getChangePasswordFields = (): passwordInputType[] => [
  {
    placeholder: 'New Password',
    label: 'New Password',
    name: 'newPassword',
    type: 'password',
    required: true,
  },
  {
    placeholder: 'Confirm Password',
    label: 'Confirm Password',
    name: 'confirmPassword',
    type: 'password',
    required: true,
    validate: (value: string, values: UpdatePwFormValues) =>
      validatePasswordsMatch(values.newPassword, value),
  },
];
